/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-Dm1irIE2.js";
import { t } from "./decorateMetadata-BhwOl-pv.js";
import { t as n } from "./decorate-DHgd5sZx.js";
import { t as r } from "./css-build-DICbZE45.js";
import { LitElement as i, html as a } from "lit";
import { customElement as o, property as s } from "lit/decorators.js";
//#endregion
//#region \0lit-plugin:css-sheet:./src/elements/assistant/assistant-avatar/assistant-avatar.css.js
var c = r(":host{display:inline-block}[part=wrapper]{width:var(--assistant-avatar-size,100%);height:var(--assistant-avatar-size,100%);border-radius:var(--assistant-chat-window-border-radius);-webkit-mask:radial-gradient(black 50%, transparent 70%) content-box 50% / var(--assistant-avatar-mask-size,150% 150%) no-repeat;mask:radial-gradient(black 50%, transparent 70%) content-box 50% / var(--assistant-avatar-mask-size,150% 150%) no-repeat;cursor:pointer;flex-shrink:0;justify-content:center;align-items:center;transition:transform .2s,width .2s,height .2s,-webkit-mask .2s,mask .2s;display:flex;overflow:hidden;-webkit-mask-composite:xor;mask-composite:exclude}[part=image]{object-fit:cover;width:100%;height:100%}"), l = class extends e(i) {
	constructor(...e) {
		super(...e), this.styles = c, this.src = "";
	}
	render() {
		return a`
            <div part="wrapper">
                <img part="image" src="${this.src}" alt="Avatar" />
            </div>
        `;
	}
};
n([s({ type: String }), t("design:type", Object)], l.prototype, "src", void 0), l = n([o("ptc-ui-assistant-avatar")], l);
//#endregion
export { l as t };

//# sourceMappingURL=assistant-avatar-Bi6OLb3t.js.map